import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WifiCalling3Icon(props: IconProps) {
    return <Icon {...props} iconKey={"wifi_calling_3"}/>
}
